import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Tailwind CSS
import App from './App';
import { registerServiceWorker } from './utils/serviceWorkerManager';

// Register Service Worker for PWA support
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker().catch((error) => {
    console.error('Failed to register service worker:', error);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);